import { Button, Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@commander/ui';
import { RiSparklingLine } from '@remixicon/react';
import { COMMANDER_GO_DEFAULTS } from '../constants.js';

interface CommanderGoButtonProps {
  onClick: () => void;
}

export function CommanderGoButton({ onClick }: CommanderGoButtonProps) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button variant="ghost" size="icon" className="h-9 w-9" onClick={onClick}>
            <RiSparklingLine className="h-4 w-4" />
            <span className="sr-only">{COMMANDER_GO_DEFAULTS.title}</span>
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <p>{COMMANDER_GO_DEFAULTS.title}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
